import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '@env';
import { API_CRON, URL_ABSOLUTA } from './contexto';

/**
 * Convierte `/luminarias` en `https://…/gestion-api-gestion/luminarias`.
 *
 * Existe para que los servicios de dominio escriban rutas relativas (igual que
 * en IRIX, donde el `HttpClientService` concatenaba `${API}${path}`) y para que
 * `httpResource()` funcione sin pasar por ninguna fachada.
 */
export const apiUrlInterceptor: HttpInterceptorFn = (req, next) => {
  const yaEsAbsoluta = /^https?:\/\//i.test(req.url);
  if (yaEsAbsoluta || req.context.get(URL_ABSOLUTA)) return next(req);

  const base = req.context.get(API_CRON) ? environment.apiCron : environment.api;
  const ruta = req.url.startsWith('/') ? req.url : `/${req.url}`;

  return next(req.clone({ url: `${base}${ruta}` }));
};
